/** Reserve the tab during the click, before an authenticated fetch can lose user activation. */
export async function openFileInNewTab(
  loadUrl: () => Promise<string>,
  revokeBlob = true,
): Promise<void> {
  const target = window.open('', '_blank');
  if (!target) throw new Error('Please allow pop-ups for this dashboard, then try again.');
  target.opener = null;
  try {
    const url = await loadUrl();
    if (revokeBlob && url.startsWith('blob:')) {
      window.setTimeout(() => URL.revokeObjectURL(url), 60_000);
    }
    target.location.replace(url);
  } catch (error) {
    target.close();
    throw error;
  }
}
